const styles = theme => ({
  updateContainer: {
    margin: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      margin: 0
    }
  },
  avatarContainer: {
    position: "relative",
    width: 210,
    height: 210,
    borderRadius: "50%",
    overflow: "hidden",
    marginBottom: theme.spacing(3)
  },
  addImageContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "25%",
    background: "rgba(255, 255, 255, 0.5)"
  },
  personPicture: {
    width: 210,
    height: 210
  },
  addAPhotoIcon: {
    width: 250,
    height: 79,
    opacity: 0.6,
    backgroundColor: theme.palette.warning.light,
    marginTop: -79
  },
  iconColor: {
    color: theme.palette.primary.main,
    width: 34,
    height: 31
  },
  personInformation: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  additionalFieldsContainer: {
    width: "35%",
    backgroundColor: "#F2F2F2",
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: theme.spacing(3)
    }
  },
  additionalFieldsTitle: {
    color: theme.palette.primary.default,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  buttonsContainer: {
    marginRight: theme.spacing(3),
    justifyContent: "space-between",
    width: "100%"
  },
  resetButton: {
    color: [theme.palette.warning.main, "!important"]
  },

  updateButton: {
    marginLeft: theme.spacing(1)
  },
  backButton: {
    color: [theme.palette.primary.default, "!important"]
  },
  labelTextColor: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/UpdateUser/styles.js